/// <amd-module name="VSSUI/Components/HeaderCommandBar/Items" />
import * as React from "react";
import { IIconProps } from "VSSUI/Components/Icon/Icon.Props";
import { IMenuItem } from "VSSUI/Menu";
import * as Resources from "VSSUI/Resources.Page";
import { IHeaderCommandBarItem } from "./HeaderCommandBar.Props";

export function getFilterItem(
    onActivate: (menuItem: IMenuItem, event?: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>) => boolean | void,
    isFiltering: boolean,
    important: boolean = true,
    label: string = Resources.Filter
): IHeaderCommandBarItem {
    return {
        ariaLabel: label,
        iconProps: getFilterItemIconProps(isFiltering),
        id: "filter",
        important: important,
        onActivate: onActivate,
        subtle: true,
        tooltipProps: { text: label }
    };
}

export function getFilterItemIconProps(isFiltering: boolean): IIconProps {
    return {
        iconName: isFiltering ? "FilterSolid" : "Filter"
    };
}

export function getFullScreenItem(
    onActivate: (menuItem: IMenuItem, event?: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>) => boolean | void,
    fullscreen: boolean,
    important: boolean = true
): IHeaderCommandBarItem {
    return {
        ariaLabel: fullscreen ? Resources.ExitFullScreen : Resources.EnterFullScreen,
        iconProps: {
            iconName: fullscreen ? "BackToWindow" : "FullScreen"
        },
        id: "fullscreen",
        important: important,
        onActivate: onActivate,
        subtle: true
    };
}

export function toggleFullScreen(newFullScreenState: boolean) {
    if (newFullScreenState) {
        document.body && document.body.classList.add("full-screen-mode");
    } else {
        document.body && document.body.classList.remove("full-screen-mode");
    }
}
